import { operational } from "@mideye/design-tokens";

export const elevation = {
  ...operational.aegis.elevation,

  glass: {
    backdropFilter: "blur(12px)",
    WebkitBackdropFilter: "blur(12px)",
  },
} as const;
